import gql from 'graphql-tag';

const createSecondaryForAccount = gql`
mutation createSecondaryForAccount($input: SecondaryPersonInput) {
  createSecondaryForAccount(input: $input) {
    accountId
    primaryPersonId
    secondaryPersonId
    firstName
    middleName
    lastName
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    emailAddress
  }
}
`;

export default createSecondaryForAccount;



// WEBPACK FOOTER //
// ./src/app/mutations/createSecondaryForAccount.js